import React, { useEffect, useState } from 'react';
import { COUNTDOWN_SECONDS } from '../data/content';
type Props = {
  tone?: 'dark' | 'light';
};
const pad = (n: number) => String(n).padStart(2, '0');
export function Countdown({
  tone = 'dark'
}: Props) {
  const [remaining, setRemaining] = useState(COUNTDOWN_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? COUNTDOWN_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hrs = Math.floor(remaining / 3600);
  const mins = Math.floor(remaining % 3600 / 60);
  const secs = remaining % 60;
  const blocks = [{
    value: pad(hrs),
    unit: 'HRS'
  }, {
    value: pad(mins),
    unit: 'MIN'
  }, {
    value: pad(secs),
    unit: 'SEC'
  }];
  const isLight = tone === 'light';
  return <div className="w-full" data-id="element-17" data-mp="10c3d5gjo1fzd">
      <p className={`text-center font-display text-sm font-bold uppercase tracking-[0.18em] ${isLight ? 'text-ink-700' : 'text-gold-400'}`} data-id="element-18" data-mp="10cv42e2bipjb">
        The special offer ends in:
      </p>
      <div className="mt-2 flex items-stretch justify-center gap-2" role="timer" aria-live="off" data-id="element-19" data-mp="xytue8i8wn21">
        {blocks.map((b, i) => <React.Fragment key={b.unit} data-id="element-20" data-mp="17pojdkmvm0r6" data-mpi={i}>
            <div className={`flex min-w-[68px] flex-col items-center rounded-lg px-3 py-2 sm:min-w-[84px] ${isLight ? 'bg-ink-900 text-white' : 'bg-white/10 text-white ring-1 ring-white/15'}`} data-id="element-21" data-mp="17ssw56eeq4tg">
              <span className="font-display text-3xl font-extrabold leading-none tabular-nums sm:text-4xl" data-id="element-22" data-mp="a5bwzhaglmf7">
                {b.value}
              </span>
              <span className="mt-1 text-[10px] font-bold uppercase tracking-[0.15em] text-gold-400" data-id="element-23" data-mp="k0c9eijq5ont">
                {b.unit}
              </span>
            </div>
            {i < blocks.length - 1 && <span className={`self-center font-display text-2xl font-bold ${isLight ? 'text-ink-700' : 'text-white/40'}`} aria-hidden="true" data-id="element-24" data-mp="1vfsj3gwy1gcw">
                :
              </span>}
          </React.Fragment>)}
      </div>
    </div>;
}